import {
  ReduxFirestoreQuerySetting,
  useFirestoreConnect,
} from "react-redux-firebase";

interface Props {
  matchId: string;
}

/* @todo this gets called too often on the listing screen */
export const useConnectMatch = ({ matchId }: Props) => {
  // Need to explicitly type here - seems to be to do with fixed length of 'where' array
  const listeners: ReduxFirestoreQuerySetting[] = [
    {
      collectionGroup: "matchPlayers",
      where: ["matchId", "==", matchId],
      storeAs: "matchPlayers",
    },
    {
      collectionGroup: "games",
      where: ["matchId", "==", matchId],
      storeAs: "games",
    },
    // Load all game data for the match (needed for scoreboard)
    {
      collectionGroup: "gamePlayers",
      where: ["matchId", "==", matchId],
      storeAs: "gamePlayers",
    },
    {
      collectionGroup: "bids",
      where: ["matchId", "==", matchId],
      storeAs: "bids",
    },
    {
      collectionGroup: "cards",
      where: ["matchId", "==", matchId],
      storeAs: "cards",
    },
  ];

  useFirestoreConnect(listeners);
};
